import Button from "@/components/button/Button"
import { useGlobalContext } from "@/components/context/GlobalContext"
import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import { SvgIcon } from "@/components/icon"
import DividerWithHex from "@/components/modal-dark/components/divider-with-hex/DividerWithHex"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { useDeliveryReportPdfMutation } from "@/graphql"
import { Col, message, Row } from "antd"
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint"
import { FC } from "react"
import { useParams } from "react-router"

const { Title, Paragraph } = WebsiteTypography

const DeliverySentNotice: FC = () => {
  const { xxl, xl, lg, md, sm } = useBreakpoint()
  const { currentDeliveryIds } = useGlobalContext()
  const { openDarkModal } = useModalDarkContext()
  const { org } = useParams()
  const [createDeliveryReportPdf, { loading: pdfLoading }] = useDeliveryReportPdfMutation()

  const generatePdfConfirmation = async () => {
    if (!currentDeliveryIds.length) return

    await createDeliveryReportPdf({
      variables: {
        input: {
          deliveryConfirmationIds: currentDeliveryIds,
          orgSlug: org || "easetech",
        },
      },
      onError: error => message.error(error.message),
      onCompleted: () => {
        openDarkModal({
          type: "delivery-report-preview",
          width: "width900",
        })
      },
    })
  }

  return (
    <Row className={"delivery-sent-notice-wrapper"} justify={"center"} style={{ marginTop: 24 }}>
      <Col span={20} xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
        <Row justify={"center"} style={{ paddingBottom: 24 }}>
          <SvgIcon type={"circled-tick"} color={"green"} />
        </Row>

        <Title level={xxl || xl || lg || md || sm ? 3 : 5} centered className={"form-section-title"}>
          <span>{"Delivery Confirmed\n"}</span>
          <span className={"bold"}>{"Successfully"}</span>
        </Title>

        <DividerWithHex marginBottom={16} marginTop={32} />

        <Paragraph centered style={{ paddingTop: 24 }} color={"white"} size={xxl || xl || lg || md || sm ? "md" : "sm"}>
          {"Delivery Confirmation created successfully. The information is now available to the link creator."}
        </Paragraph>

        <Row justify={"center"} style={{ paddingTop: 40 }}>
          <Col xxl={12} xl={12} lg={12} md={10} sm={14} xs={16}>
            <Button
              btnType={"primary"}
              onClick={generatePdfConfirmation}
              text={"Generate Delivery Report"}
              size={"large"}
              icon={<SvgIcon type={"pdf-logo"} color={"white"} />}
              loading={pdfLoading}
              block
            />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default DeliverySentNotice
